import React from 'react';
import * as Styled from './TabButton.styled';
import { TabButtonProps } from './TabButton.typed';

const TabButton = React.forwardRef<HTMLButtonElement | null, TabButtonProps>(
  ({ active, inline = true, height, type = 'button', ...props }, ref) => {
    return (
      <Styled.TabButton
        ref={ref}
        active={active}
        inline={inline}
        height={height}
        type={type}
        data-testid="tab-button"
        {...props}
      ></Styled.TabButton>
    );
  },
);

export default TabButton;
